module.exports = __webpack_public_path__ + "static/img/dea2fe657e8ef63bc4b22c311f0da0b2.f14d033.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dea2fe657e8ef63bc4b22c311f0da0b2.png
// module id = jcWh
// module chunks = 73